window.perPage = 5;
window.sort = 'date-desc';
window.searchValue = '';
window.currentPageNumber = 1;
window.onload = async (event) => {
  await preLoadData();
  await loadFlterOptions();
  await fetchCommentsFromFirebase();
  const overlay = document.getElementById('overlay');
  const modals = document.querySelectorAll('.modal');
  const html = document.querySelector('html');
  
  overlay.addEventListener("click", () => {
    overlay.classList.remove("active");
    html.classList.remove('modal-open');
    modals.forEach(modal => {
      modal.classList.remove("active");
    });
  });
  window.state.selectedItem = null;
  document.querySelectorAll("#review-container > div:nth-child(2) > div.review-footer > div > video").forEach(video => {
    video.addEventListener('click', e => {
      e.preventDefault();     // native oynatmayı engelle
      e.stopPropagation();
      const index = e.target.dataset.index;
      let selectedComment = window.comments.filter(x => x.id == index);
      if(selectedComment.length === 0){
        selectedComment = window.visibleComments.filter(x => x.id == index)
      }
      clickButton('detail')
      window.state.selectedItem = selectedComment[0];
    });
  });

};
async function preLoadData(){
    fetch("https://us-central1-review-c8033.cloudfunctions.net/getCommentStats")
    .then(response => response.json())
    .then(data => {
    let averageRateElems = document.getElementById('inhouse-review-score');
      averageRateElems.innerText = data.averageRating != null ? Math.ceil(data.averageRating * 10) / 10 : 0;
      let totalCount = document.getElementById('review-count');
      totalCount.innerText = `(Toplam ${data.count} Yorum)`;
    })
    .catch(error => {
      console.error("API çağrısı hatası:", error);
    });
    
}
async function loadFlterOptions(){
    fetch("https://us-central1-review-c8033.cloudfunctions.net/getCommentFilterOption")
    .then(response => response.json())
    .then(data => {
      window.filterOptions = data.filterOptions;
      window.filterTotalCount = data.count;
      window.setupFilterOptions();
    })
    .catch(error => {
      console.error("API çağrısı hatası:", error);
    });
    
}


/**
 * Yorumun HTML çıktısını hazırlar
 * @param {Object} comment 
 * @returns {string} 
 */
function createCommentHtml(comment) {
  let media = (comment.medias ? comment.medias[0] : null);
  if (media) {
    return `
    <img 
      src="${media.url.replace(/(\.jpg|\.png)/, '_100x100$1')}"
      srcset="
        ${media.url.replace(/(\.jpg|\.png)/, '_100x100$1')} 100w,
        ${media.url.replace(/(\.jpg|\.png)/, '_300x300$1')} 300w,
        ${media.url.replace(/(\.jpg|\.png)/, '_600x600$1')} 600w
      "
      sizes="(max-width: 600px) 100px, 300px"
      width="400" 
      height="400" 
      loading="lazy" 
      alt="Yorum Görseli"
      style="object-fit: cover;"
      data-index="${comment.id}" 
      class="show-detail-button"
    >
  `
  }
  // return medias.map(media => `
  //   <img 
  //     src="${media.url.replace(/(\.jpg|\.png)/, '_100x100$1')}"
  //     srcset="
  //       ${media.url.replace(/(\.jpg|\.png)/, '_100x100$1')} 100w,
  //       ${media.url.replace(/(\.jpg|\.png)/, '_300x300$1')} 300w,
  //       ${media.url.replace(/(\.jpg|\.png)/, '_600x600$1')} 600w
  //     "
  //     sizes="(max-width: 600px) 100px, 300px"
  //     width="400" 
  //     height="400" 
  //     loading="lazy" 
  //     alt="Yorum Görseli"
  //     style="object-fit: cover;"
  //     data-index="${comment.id}" 
  //     class="show-detail-button"
  //   >
  // `).join("");
}


function clickButton(params) {
    const overlay = document.getElementById('overlay');
    const html = document.querySelector('html');
    const modal = document.getElementById(params);
      overlay.classList.add("active");
      modal.classList.add("active");
      html.classList.add('modal-open');
};



function renderComments() {
  const overlay = document.getElementById('overlay');
  const start = (window.currentPageCount - 1) * window.perPage;
  const end = start + perPage;
  let comments = window.comments;
  window.commentArray = comments;
  window.showCommentList = comments;
  const container = document.getElementById("review-container");
  container.innerHTML = "";

  if(comments.length <= 0){
    const html = `
      <div><p style="display: flex;justify-content: center;align-items: center;">Yorum bulunamadı.</p></div>
    `;
    
    container.innerHTML += html;
    container.style.minHeight = 'unset';
  } else {
    
  
  showCommentList.forEach((comment, index) => {
    
    let renderProductHTML = "";
    //const productsHTML = comment.products.map(product => `<span>${product.title}</span>`).join("");
    const firstMedia = comment.medias?.[0];

    const imageHTML = firstMedia
      ? firstMedia.url.includes('mp4')
        ? `
          <video 
            src="${firstMedia.url.replace(/(\.mp4|\.webm)/, '_small$1')}" 
            controls 
            width="400" 
            height="400" 
            data-index="${comment.id}" 
            class="show-detail-button"
            style="width:6vw"
          ></video>`
        : `
          <img 
            src="${firstMedia.url.replace(/(\.jpg|\.png)/, '_100x100$1')}" 
            alt="comment-img" 
            data-index="${comment.id}"
            loading="lazy" 
            class="show-detail-button"
            width="400" 
            height="400"
          >`
      : '';

    if(comment.products.length > 0){
      const productHandle = comment.products[0].handle !== ''  ? comment.products[0].handle : '#';
      const productTitle = comment.products[0].title !== '' ? comment.products[0].title : '';
      renderProductHTML = `
      <div class="product-detail">     
        <a href='/products/${productHandle}'>${productTitle}</a>
      </div>`
    }
    const date = new Date(comment.date);
    const formattedDate = date.toISOString().split("T")[0];
    const formattedTime = date.toTimeString().split(" ")[0];
    const html = `
      <div>
      <div class="review text-wrapper">
        
        <div class="rating" data-rating="${comment.rating}">
          <span class="icon-star"></span>
          <span class="icon-star"></span>
          <span class="icon-star"></span>
          <span class="icon-star"></span>
          <span class="icon-star"></span>
        </div>
        <div class="info">
          <p><span>${comment.userName}</span> | <span>${formattedDate}</span> | <span>${formattedTime}</span></p>
        </div>
        <div class="review-header">
          <h2>${comment.title == null ? '' : comment.title}</h2>
        </div>
        <div class="review-text clamp-text" id='${comment.id}-text'>
          <p>${comment.text}</p>
        </div>
        <div class="toggle-button-area" id='${comment.id}-button' style="display: none;">
          <button data-index="${comment.id}" class='toggle-button'>Devamını Oku</button>
        </div>
      </div>
      <div class="review-footer">
        <div class="media">
          ${imageHTML}
        </div>
      </div>
      ${renderProductHTML}
      ${renderReplyHTML(comment.reply, comment.date)}
      <hr>
      </div>
    `;
    container.innerHTML += html;
    
    const text = document.getElementById(`${comment.id}-text`);
    const button = document.getElementById(`${comment.id}-button`);

    const isOverflowing = text.scrollHeight > text.clientHeight;
    if (isOverflowing) {
      button.style.display = 'flex';
    }
  });
      document.querySelectorAll('.toggle-button').forEach(function (button) {
      button.addEventListener('click', function () {
        const paragraph = this.parentNode.parentNode.parentNode.getElementsByClassName('clamp-text')[0];
        const isExpanded = paragraph.classList.toggle('expanded');
        this.textContent = isExpanded ? 'Daha az göster' : 'Devamını Oku';
      });
    });
  }
  
  renderPagination();
  overlay.click();
  document.querySelectorAll(".show-detail-button").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      const index = e.target.dataset.index;
      let selectedComment = window.comments.filter(x => x.id == index);
      if(selectedComment.length === 0){
        selectedComment = window.visibleComments.filter(x => x.id == index)
      }
      clickButton('detail')
      window.state.selectedItem = selectedComment[0];
    });
  });
}
function renderPagination() {
  const totalPages = Math.ceil(window.filterTotalCount / window.perPage);
  window.totalPage = totalPages;
  const paginationHTML = generatePagination(window.currentPageNumber, totalPages);
  document.getElementById("pagination").innerHTML = paginationHTML;
}


function renderReplyHTML(reply, commentDate) {
  if((reply !== undefined) && (reply.length > 0) ){
    const date = reply[0].date === '' ? new Date(commentDate) : new Date(reply[0].date);
    const formattedDate = date.toISOString().split("T")[0];
    const formattedTime = date.toTimeString().split(" ")[0];
    return `
        <div class="replay">
          <div class='header'>
            <div>
              <img src="${'https://cdn.shopify.com/s/files/1/0083/3375/4432/files/logo_tr-2_1.png?v=1632668430'}">
            </div>
            <p><span>${formattedDate}</span> | <span>${formattedTime}</span></p>
          </div>
          <div class='content'>${reply[0].text}</div>
        </div>
      `;
  } else{
    return ''
  }
}
  async function fetchCommentsFromFirebase(productPage='') {
    let actionArea = document.querySelector("#smooth-scroll > div.badge-actions");
    actionArea.classList.add("disabled");
    const params = new URLSearchParams();
    let productHandle = window.location.href.includes('products') ? window.location.href.split('/products/')[1] : '';
    productHandle = productHandle.includes('?') ? productHandle.split('?')[0] : productHandle;
    productPage = productPage !== '' ? productPage : productHandle;
    
    // Sayfa numarası
    if (window.currentPageNumber > 0) {
      params.append("page", window.currentPageNumber);
    }
    

    // collectionList (array)
    if (window.collections && window.collections.length > 0) {
      window.collections.forEach((s) => params.append("collection", s));
    }

    // fabricTextureList (array)
    if (window.texture && window.texture.length > 0) {
      window.texture.forEach((t) => params.append("fabricTextureList", t));
    }

    // hasMedia (boolean)
    if (typeof window.hasMedia === "boolean") {
      params.append("hasMedia", window.hasMedia);
    }

    // ratingList (array)
    if (window.rating && window.rating.length > 0) {
      window.rating.forEach((r) => params.append("ratingList", r));
    }
    // Arama
    if (window.searchValue !== '') {
      params.append("search", window.searchValue);
    }

    // Sıralama
    if (window.sort) {
      params.append("sort", window.sort);
    }

    let url = '';
    if(params.size > 0){
       url = `https://getcommentswithparams-dqrht2fvya-uc.a.run.app?${params.toString()}`;
    } else{
      
     url = `https://getcommentswithparams-dqrht2fvya-uc.a.run.app`;
    }
    if(productPage !== ""){
      url=`https://us-central1-review-c8033.cloudfunctions.net/getCommentsWithProductID?limit=5&productid=${productPage}&${params.toString()}`;
    }
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Bir hata oluştu");
      }

      window.comments = data.comments;
      window.filterTotalCount = data.count;
      renderComments();
      if (productPage !== ''){
        let averageRateElems = document.getElementById('inhouse-review-score');
        averageRateElems.innerText = data.averageRating != null ? data.averageRating : 0;
        let totalCount = document.getElementById('review-count');
        let totalCountSmall = document.getElementById('review-count-small');
        totalCount.innerText = `(Toplam ${data.count} Yorum)`;
        totalCountSmall.innerText = ` ${data.count} Yorum`;
        window.filterOptions = data.filterOptions;
        actionArea.classList.remove("disabled");
      }
      console.log(window.filterOptions)
      window.setupFilterOptions();
      // TODO: data.comments ile UI’yi güncelle

  renderPagination();
    } catch (error) {
      console.error("Yorum verileri alınırken hata oluştu:", error.message);
    }
  }


window.renderComments = renderComments;
window.renderPagination = renderPagination;
window.fetchCommentsFromFirebase=fetchCommentsFromFirebase;